/**
 * Shared player control frame sizes.
 *
 * Call sites pass density (`sm` | `md`). Concrete play buttons own their
 * own icon recipes; this module only holds button/row frame classes.
 */

export type PlayerControlSize = "sm" | "md"

/** Elevated toolbar size used only for compact-middle skip buttons. */
export type ToolbarButtonSize = PlayerControlSize | "lg"

/** Round play buttons: density scale + hero `lg` for the initial play button. */
export type CircleButtonSize = PlayerControlSize | "lg"

/** Toolbar / square icon button frames (40 / 48 / 56). */
export const TOOLBAR_BUTTON_SIZE_CLASS: Record<ToolbarButtonSize, string> = {
  sm: "size-10",
  md: "size-12",
  lg: "size-14",
}

/** Round play button frames (64 / 80 / 140). */
export const CIRCLE_BUTTON_SIZE_CLASS: Record<CircleButtonSize, string> = {
  sm: "size-16",
  md: "size-20",
  lg: "size-[140px]",
}

/** Row height for playtime / control rows matching toolbar buttons. */
export const CONTROL_ROW_HEIGHT_CLASS: Record<PlayerControlSize, string> = {
  sm: "h-10",
  md: "h-12",
}

/** Volume track / divider heights aligned with toolbar buttons. */
export const VOLUME_DIVIDER_HEIGHT_CLASS: Record<PlayerControlSize, string> = {
  sm: "h-8",
  md: "h-10",
}
